import {redux} from "@swarm2/core"
import {assert} from "@swarm2/assert"
import ReactGA from "react-ga"
import _ from "lodash"
import lifecycle from "recompose/lifecycle"

import {withRouter} from "react-router"

// sadly, ReactGA needs a global, not context
if (process.env.NODE_ENV !== "test") {
  ReactGA.initialize(
    assert(
      redux.envConfig.googleAnalyticsId,
      "googleAnalyticsId",
      redux.envConfig,
    ),
  )
}

const ANALytics = _.flowRight(
  // apparently my sense of humor hasn't changed since I was 12
  withRouter,
  lifecycle({
    componentWillMount() {
      this.props.history.listen(location => {
        ReactGA.set({page: location.pathname})
        ReactGA.pageview(location.pathname)
      })
    },
  }),
)(props => null)
export default ANALytics



// WEBPACK FOOTER //
// ./src/app/Analytics.js